// Class used to manage the creation and clearing of intervals and corresponding timeouts (Created ny human seriously)

export default class TimedIntervalManager {
  constructor() {
    this.activeIntervals = new Set();
    this.activeTimeouts = new Set();
  }

  // Creates an interval and a corresponding timeout
  // intervalCallback: The callback function for the interval
  // intervalTiming: The timing of the interval
  // intervalTimeoutDuration: The duration of the timeout
  // timeOutCallback: The callback function for the timeout
  createInterval(intervalCallback, intervalTiming, intervalTimeoutDuration, timeOutCallback) {
    this.clearAll();

    const interval = setInterval(intervalCallback, intervalTiming);
    const timeout = setTimeout(() => {
      this.clearInterval(interval);
      timeOutCallback();
    }, intervalTimeoutDuration);

    this.activeIntervals.add(interval);
    this.activeTimeouts.add(timeout);

    return { interval, timeout };
  }

  clearInterval(interval) {
    if (this.activeIntervals.has(interval)) {
      clearInterval(interval);
      this.activeIntervals.delete(interval);
    }
  }

  clearTimeout(timeout) {
    if (this.activeTimeouts.has(timeout)) {
      clearTimeout(timeout);
      this.activeTimeouts.delete(timeout);
    }
  }

  clearAll() {
    this.activeIntervals.forEach((interval) => {
      clearInterval(interval);
      this.activeIntervals.delete(interval);
    });

    this.activeTimeouts.forEach((timeout) => {
      clearTimeout(timeout);
      this.activeTimeouts.delete(timeout);
    });
  }

  hasActiveIntervals() {
    return this.activeIntervals.size > 0 || this.activeTimeouts.size > 0;
  }
}
